import React, { useState, useEffect } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody
} from '@material-ui/core'

import { renewEnrollmentHistoryService, renewEnrollmentService } from '../services'

const RenewEnrollmentHistoryDialog = ({ open, onClose, groupStudentId }) => {
  const [loading, setLoading] = useState(false)
  const [history, setHistory] = useState([])
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!open) return

    const fetchHistory = async () => {
      setLoading(true)
      setError(null)

      try {
        const { success, payload } = await renewEnrollmentHistoryService.getRenewEnrollmentHistory(groupStudentId)

        if (success && payload?.history) {
          setHistory(payload.history)
        } else {
          setError('Não foi possível carregar o histórico')
        }
      } catch (err) {
        setError('Erro ao carregar histórico')
      } finally {
        setLoading(false)
      }
    }

    fetchHistory()
  }, [open, groupStudentId])


  const generatePdf = async (id) => {
    setLoading(true)

    await renewEnrollmentService.getPdf(groupStudentId, id)

    setLoading(false)
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      disableRestoreFocus
      maxWidth="md"
      fullWidth
    >
      <DialogTitle style={{ textAlign: 'center' }}>
        Histórico de solicitações (Rematrículas)
      </DialogTitle>
      <DialogContent>
        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
            <CircularProgress />
          </div>
        ) : error ? (
          <Typography color="error">{error}</Typography>
        ) : history.length === 0 ? (
          <DialogContentText>
            Nenhum histórico encontrado.
          </DialogContentText>
        ) : (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell><b>Usuário</b></TableCell>
                <TableCell><b>Aluno</b></TableCell>
                <TableCell><b>Ano Escolaridade</b></TableCell>
                <TableCell><b>Quadro Curricular</b></TableCell>
                <TableCell><b>Data</b></TableCell>
                <TableCell><b>Operação</b></TableCell>
                <TableCell><b>Ações</b></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {history.map(item => (
                <TableRow key={item.id} hover>
                  <TableCell>{item.user}</TableCell>
                  <TableCell>{item.student}</TableCell>
                  <TableCell>{item.degree}</TableCell>
                  <TableCell>{item.curriculum}</TableCell>
                  <TableCell>{item.date}</TableCell>
                  <TableCell>{item.operation}</TableCell>
                  <TableCell>
                    <Button disabled={loading} color="primary" onClick={() => (generatePdf(item.id))}>Imprimir Comprovante</Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="primary" autoFocus>
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default RenewEnrollmentHistoryDialog
